export const API_BASE_URL = process.env.API_BASE_URL || "";
export const API_BASE_URL_V2 = toApiBaseUrlV2(API_BASE_URL);
export function normalizeApiBaseUrl(baseUrl = API_BASE_URL) {
    return baseUrl.replace(/\/+$/, "");
}
export function toApiBaseUrlV2(baseUrl = API_BASE_URL) {
    const normalized = normalizeApiBaseUrl(baseUrl);
    if (normalized.endsWith("/v2")) {
        return normalized;
    }
    if (normalized.endsWith("/v1")) {
        return `${normalized.slice(0, -3)}/v2`;
    }
    return `${normalized}/v2`;
}
